var _mask, _mask2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBottlesSaved(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h2.61193717v1.31594136h-2.61193717z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h13.207644v13.8679437h-13.207644z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h30v30h-30z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    transform: "translate(8.5 5.109948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.2608377 1.31594136h2.09026178c.14408377 0 .26083769-.12259162.26083769-.27387958v-.32918325c0-.39317277-.30450262-.71290052-.67884816-.71290052h-1.25424084c-.37434555 0-.67884817.31972775-.67884817.71290052v.32918325c0 .15128796.11675393.27387958.2608377.27387958",
    mask: "url(#a)",
    transform: "translate(5.137686)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.3176021 13.8679437c-.2278534 0-.4556021-.0912565-.6294241-.2737696l-11.42753926-11.99891625c-.34753926-.36491623-.34753926-.95665445 0-1.32157068.3477487-.36491623.91120419-.36491623 1.25884817 0l11.42753929 11.99891623c.3475392.3649162.3475392.9566545 0 1.3215707-.173822.1825131-.4015707.2737696-.6294241.2737696",
    mask: "url(#b)",
    transform: "translate(0 4.714231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.89347644 11.9147293v-4.56029841c0-.66628272-.17717278-1.31750262-.51235602-1.88318325l-1.63015707-2.75242932v-.68992146c0-.15128796-.11675393-.27387958-.2608377-.27387958h-2.09026178c-.14408377 0-.26083769.12259162-.26083769.27387958v.69321989l-1.486911 2.63918325z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.89347644 18.2898675-6.79246073-7.1320837v8.3913141c0 .0030785.00010471.0061571.00020942.0092356-.00010471.0029686-.00020942.0057173-.00020942.0075864 0 .6911309.53434555 1.2534031 1.1913089 1.2534031h.24272251c.36596859 0 .7-.1786649.92041885-.4613403.22052356.2826754.55445026.4613403.92041885.4613403h.24272251c.36596859 0 .69989529-.1786649.92041885-.4613403.22031413.2826754.55434555.4613403.92031413.4613403h.24272252c.65696335 0 1.19141361-.5622722 1.19141361-1.2534031 0-.0029686-.00010471-.0059372-.00010471-.0086859s.00010471-.0053874.00010471-.0081361z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottlesSaved);
export default __webpack_public_path__ + "static/media/bottlesSaved.ce173491776c97cdb8eecce29b338ff0.svg";
export { ForwardRef as ReactComponent };